module.exports = import("pdfmake/build/pdfmake.js");;